import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actions from '../../actions/AccidentBenefitsSets'
import { createFlashMessage } from '../../actions/FlashMessages'
import BenefitsSetEdit from '../BenefitsSet/BenefitsSetEdit'
import AccidentBenefitsSetForm from './AccidentBenefitsSetForm'
import issuerActions from '../../actions/Issuers'
import historyActions from '../../actions/BenefitsSetFieldHistories'
import howieServiceAreaActions from '../../actions/HowieServiceAreas'
import platformActions from '../../actions/Platforms'

const mapStateToProps = (state) => {
  const slice = state.accidentBenefitsSets.update
  const showSlice = state.accidentBenefitsSets.show
  const remoteOptionsSelectStates = {
    issuers: state.issuers.index,
    howie_service_areas: state.howieServiceAreas.index,
    privileged_platforms: state.platforms.index
  }
  const configuration = state.login.session.configuration.accident_benefits

  const historySlice = state.benefitsSetFieldHistory.index

  return {
    generalError: slice.generalError,
    resourceErrors: slice.resourceErrors,
    attributes: showSlice.attributes,
    id: slice.id,
    updated: slice.updated,
    requestComplete: slice.requestComplete,
    configuration,
    remoteOptionsSelectStates,
    benefitsSetFieldHistory: historySlice.records,
    benefitsSetForm: AccidentBenefitsSetForm,
    benefitsSetUrl: 'accident_benefits',
    productLine: 'Accident'
  }
}

const mapDispatchToProps = (dispatch) => ({
  update: bindActionCreators(actions.update.main, dispatch),
  show: bindActionCreators(actions.show.main, dispatch),
  reset: bindActionCreators(actions.update.reset, dispatch),
  showReset: bindActionCreators(actions.show.reset, dispatch),
  history: bindActionCreators(historyActions.index.main, dispatch),
  resetHistory: bindActionCreators(historyActions.index.reset, dispatch),

  remoteOptionsSelectActions: {
    howieServiceAreasIndex: {
      main: bindActionCreators(howieServiceAreaActions.index.main, dispatch),
      reset: bindActionCreators(howieServiceAreaActions.index.reset, dispatch)
    },
    issuersIndex: {
      main: bindActionCreators(issuerActions.index.main, dispatch),
      reset: bindActionCreators(issuerActions.index.reset, dispatch)
    },
    platformsIndex: {
      main: bindActionCreators(platformActions.index.main, dispatch),
      reset: bindActionCreators(platformActions.index.reset, dispatch)
    }
  },

  createFlashMessage
})

export default connect(mapStateToProps, mapDispatchToProps)(BenefitsSetEdit)
